import styled from '@emotion/styled'

export const OfferString = styled.div`
  color: #505050;
  font-family: 'Roboto';
  font-size: 0.75rem;
  white-space: now-wrap;
`
